import { proxy } from 'valtio'

const masterwalletStore = proxy({
  search: null
})

export default masterwalletStore
